export const SET_BRAND_INFO = 'SET_BRAND_INFO';